import {Alert, Button, Col, Row, Space} from "antd";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {OfferingAutomations} from "../../../../../components/offering-form/automations-step";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useCreateSessionContext} from "../../context/create-session";
import {useSession} from "../../../../../features/sessions";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {CreateServiceSuccessModal} from "../../success-modal";
import {
  OFFERING_CREATE_DRAFT_KEYS,
  useClearOfferingCreateDraft,
} from "../../../../../utils/offering-create-draft";

export function CreateSessionAutomationsStep() {
  const navigate = useNavigate();
  const {
    dispatch,
    state: {sessionData},
  } = useCreateSessionContext();
  const [openSuccessfulModal, setOpenSuccessfulModal] = useState(false);
  const clearSessionDraft = useClearOfferingCreateDraft(
    OFFERING_CREATE_DRAFT_KEYS.session
  );

  const sessionId = sessionData?.id ?? 0;
  const sessionQuery = useSession(sessionId, sessionId > 0);

  if (sessionQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (sessionQuery.isError) {
    return (
      <Alert
        message="Error"
        description={sessionQuery.error.message}
        type="error"
        showIcon
      />
    );
  }

  const session = sessionQuery.data!;

  const goBack = () =>
    dispatch({
      type: "update-create-session-form-step",
      payload: "coverImagesUpload",
    });

  const handleModalOk = () => {
    setOpenSuccessfulModal(false);
    clearSessionDraft();
    navigate("/calls");
  };

  return (
    <>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingAutomations
          contextOfferingId={session.id}
          onPublishSuccess={() => setOpenSuccessfulModal(true)}
          renderWizardFooter={() => (
            <Row gutter={[0, 16]}>
              <Col span={24} sm={12}>
                <StyledServiceButtonWrapper>
                  <Button onClick={goBack} block size="small" type="default">
                    Back
                  </Button>
                  <Button
                    block
                    type="primary"
                    size="small"
                    onClick={() => setOpenSuccessfulModal(true)}
                  >
                    Create session
                  </Button>
                </StyledServiceButtonWrapper>
              </Col>
            </Row>
          )}
        />
      </Space>
      <CreateServiceSuccessModal
        openSuccessfulModal={openSuccessfulModal}
        handleOk={handleModalOk}
        slug={session.slug}
        serviceId={session.id}
        serviceName={session.name}
        modalDescription="Your 1:1 session has been successfully created! Share your session link to start getting bookings"
        modalTitle="1:1 Session created!"
        tinyUrl={session.tinyUrl}
      />
    </>
  );
}
